
import QSelect from "quasar/src/components/select/QSelect";

export default {
    name: "QfSelect",
    mixins: [QSelect],
    render(h) {
        const child = [];

        if (this.hasChips) {
            const el = h("div", {
                staticClass: "col row items-center q-input-chips",
                class: this.alignClass
            }, this.selectedOptions.map((opt, index) => h("q-chip", {
                key: index,
                props: {
                    small: true,
                    closable: this.editable && !opt.disable,
                    color: this.__getChipBgColor(opt.color),
                    textColor: this.__getChipTextColor(opt.color),
                    icon: opt.icon,
                    iconRight: opt.rightIcon,
                    avatar: opt.avatar
                },
                on: {
                    hide: () => { this.__toggleMultiple(opt.value, this.disable || opt.disable); }
                },
                nativeOn: {
                    click: e => { e.stopPropagation(); }
                }
            }, [
                h("div", { domProps: { innerHTML: opt.label } })
            ])));
            child.push(el);
        } else {
            const el = h("div", {
                staticClass: "col q-input-target ellipsis",
                class: this.fakeInputClasses
            }, [h("div", { staticClass: "ellipsis", domProps: { innerHTML: this.fakeInputValue } })]);
            child.push(el);
        }

        child.push(h("q-popover", {
            ref: "popover",
            staticClass: "column no-wrap",
            class: this.dark ? "bg-dark" : null,
            props: {
                cover: this.popupCover,
                keepOnScreen: true,
                disable: !this.editable,
                anchorClick: false,
                maxHeight: this.popupMaxHeight
            },
            slot: "after",
            on: {
                show: this.__onShow,
                hide: () => { this.__onClose(true); }
            },
            nativeOn: {
                keydown: this.__keyboardHandleKey
            }
        }, [
            (this.filter && h("q-search", {
                ref: "filter",
                staticClass: "col-auto",
                style: "padding: 10px;",
                props: {
                    value: this.terms,
                    placeholder: this.filterPlaceholder || this.$t("userInterface.containerFilter"),
                    debounce: 100,
                    color: this.color,
                    dark: this.dark,
                    noParentField: true,
                    noIcon: true
                },
                on: {
                    input: val => {
                        this.terms = val;
                        this.reposition();
                    }
                }
            })) || void 0,

            (this.visibleOptions.length && h("q-list", {
                staticClass: "no-border scroll",
                props: {
                    separator: this.separator,
                    dark: this.dark
                }
            }, this.visibleOptions.map((opt, index) => h("q-item-wrapper", {
                key: index,
                class: [
                    opt.disable ? "text-faded" : "cursor-pointer",
                    index === this.keyboardIndex ? "q-select-highlight" : "",
                    opt.disable ? "" : "cursor-pointer",
                    opt.className || ""
                ],
                props: {
                    cfg: opt,
                    slotReplace: true,
                    active: this.multiple ? void 0 : this.value === opt.value
                },
                nativeOn: {
                    "!click": () => {
                        const action = this.multiple ? "__toggleMultiple" : "__singleSelect";
                        this[action](opt.value, opt.disable);
                    },
                    mouseenter: e => {
                        !opt.disable && this.__mouseEnterHandler(e, index);
                    }
                }
            }, [
                this.multiple
                    ? h(this.toggle ? "q-toggle" : "q-checkbox", {
                        slot: this.toggle ? "right" : "left",
                        props: {
                            keepColor: true,
                            color: opt.color || this.color,
                            dark: this.dark,
                            value: this.optModel[opt.index],
                            disable: opt.disable,
                            noFocus: true
                        }
                    })
                    : (this.radio && h("q-radio", {
                        slot: "left",
                        props: {
                            keepColor: true,
                            color: opt.color || this.color,
                            dark: this.dark,
                            value: this.value,
                            val: opt.value,
                            disable: opt.disable,
                            noFocus: true
                        }
                    })) || void 0
            ])))) || void 0
        ]));

        if (this.isClearable) {
            child.push(h("q-icon", {
                slot: "after",
                staticClass: "q-if-control",
                props: { name: this.$q.icon.input[`clear${this.isInverted ? "Inverted" : ""}`] },
                nativeOn: {
                    click: this.clear
                }
            }));
        }

        child.push(
            h("q-icon", this.readonly ? { slot: "after" } : {
                slot: "after",
                staticClass: "q-if-control",
                props: { name: this.$q.icon.input.dropdown }
            })
        );

        return h("q-input-frame", {
            ref: "input",
            staticClass: "q-select qf-select",
            props: {
                prefix: this.prefix,
                suffix: this.suffix,
                stackLabel: this.stackLabel,
                floatLabel: this.floatLabel,
                error: this.error,
                warning: this.warning,
                disable: this.disable,
                readonly: this.readonly,
                inverted: this.inverted,
                invertedLight: this.invertedLight,
                dark: this.dark,
                hideUnderline: this.hideUnderline,
                before: this.before,
                after: this.after,
                color: this.color,
                noParentField: this.noParentField,
                focused: this.focused,
                focusable: true,
                length: this.length,
                additionalLength: this.additionalLength
            },
            nativeOn: {
                click: this.togglePopup,
                focus: this.__onFocus,
                blur: this.__onBlur,
                keydown: this.__keyboardHandleKey
            }
        }, child);
    }
};
